export const DISCIPLINE_NAMES = {
  ATH: 'Athletics',
  BK3: '3x3 Basketball',
  BOX: 'Boxing',
  CTR: 'Track Cycling',
  GAR: 'Artistic Gymnastics',
  JUD: 'Judo',
  LBO: 'Lawn Bowls',
  NBL: 'Netball',
  PWL: 'Powerlifting',
  SWM: 'Swimming',
  WLF: 'Weightlifting'
};

export const getDisciplineName = (code) => {
  if (!code) return '';
  return DISCIPLINE_NAMES[code] || code;
};
